import { IMatch } from '../../typings/searchResults'
import { Site } from '../constants/siteList'
import ga from '../utils/ga'
import { getCurrentSiteDomain } from '../utils/sites'

export const reportEditCartEntryAttempt = ({ page }: { page: string }) => {
  ga('send', {
    hitType: 'pageview',
    page,
    title: 'Modal: Edit cart entry'
  })
}

export const reportCartSupportUpgrade = ({
  item,
  currentSite,
  license,
  price,
  support
}: {
  item: IMatch
  currentSite: Site
  license: string
  price: number
  support: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  ga('ec:addProduct', {
    id: item.id,
    name: item.name,
    variant: license,
    category: `${currentSiteDomain}/${item.classification}`,
    brand: item.author_username,
    price,
    quantity: '1',
    dimension14: support
  })
  ga('ec:setAction', 'add')
  ga('send', 'event', 'Ecommerce', 'click', 'Search support upgrade')
}
